var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_104812",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: #828282;\n      }\n\n      .st3 {\n        isolation: isolate;\n      }\n\n      .st4 {\n        fill: #fff;\n      }\n\n      .st1 {\n        stroke: #707070;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 98,
    height: 102,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 101,
    rx: 3.5,
    ry: 3.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Two",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.2,86v-7.1h2.1c.6,0,1.2.1,1.7.4s.9.7,1.1,1.2.4,1.1.4,1.8v.4c0,.7-.1,1.3-.4,1.8s-.7.9-1.1,1.2-1.1.4-1.7.4h-2ZM35.4,79.9v5.1h.8c.6,0,1.1-.2,1.5-.6.3-.4.5-1,.5-1.7v-.4c0-.8-.2-1.4-.5-1.8s-.8-.6-1.5-.6h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.6,79.3c0-.2,0-.3.2-.5s.3-.2.5-.2.4,0,.5.2.2.3.2.5,0,.3-.2.4c-.1.1-.3.2-.5.2s-.4,0-.5-.2c-.1-.1-.2-.3-.2-.4ZM41.8,86h-1.2v-5.3h1.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45,84.5l1.1-3.8h1.2l-1.8,5.3h-1l-1.8-5.3h1.2l1.1,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.1,79.3c0-.2,0-.3.2-.5s.3-.2.5-.2.4,0,.5.2.2.3.2.5,0,.3-.2.4c-.1.1-.3.2-.5.2s-.4,0-.5-.2c-.1-.1-.2-.3-.2-.4ZM49.3,86h-1.2v-5.3h1.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.4,83.3c0-.8.2-1.5.6-2,.4-.5.9-.7,1.5-.7s1,.2,1.4.6v-2.7h1.2v7.5h-1.1v-.5c-.4.4-.9.6-1.5.6s-1.1-.2-1.5-.7c-.4-.5-.6-1.2-.6-2ZM51.6,83.4c0,.5.1,1,.3,1.3.2.3.5.5.9.5s.8-.2,1.1-.6v-2.3c-.2-.4-.6-.6-1.1-.6s-.7.2-.9.5c-.2.3-.3.8-.3,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.6,86.1c-.8,0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9h0c0-.7.1-1.1.3-1.6.2-.4.5-.7.9-1,.4-.2.8-.3,1.2-.3.7,0,1.3.2,1.7.7.4.5.6,1.1.6,1.9v.5h-3.5c0,.4.2.8.4,1,.3.3.6.4,1,.4s1-.2,1.3-.7l.6.6c-.2.3-.5.6-.8.7-.4.2-.8.3-1.2.3ZM58.5,81.6c-.3,0-.6.1-.8.3s-.3.5-.4,1h2.3c0-.5-.1-.8-.3-1-.2-.2-.4-.3-.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.4,81.8c-.2,0-.3,0-.5,0-.5,0-.9.2-1.1.6v3.6h-1.2v-5.3h1.1v.6c.3-.5.7-.7,1.2-.7s.3,0,.4,0v1.1Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "font_download_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61963",
    className: "st0",
    d: "M26.4,16.3h45v45H26.4V16.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146237"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65,33h-32c-2.2,0-4-1.8-4-4v-4c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v4c0,2.2-1.8,4-4,4ZM33,23c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2h32c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2h-32Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_146239",
    className: "st2",
    d: "M30,37h38c.6,0,1,.4,1,1h0c0,.6-.4,1-1,1H30c-.6,0-1-.4-1-1h0c0-.6.4-1,1-1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146238"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65,55h-32c-2.2,0-4-1.8-4-4v-4c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v4c0,2.2-1.8,4-4,4ZM33,45c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2h32c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2h-32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerComponent);
export default __webpack_public_path__ + "static/media/DividerComponent.a01f72c61fa448fa4c220007c4214e6b.svg";
export { ForwardRef as ReactComponent };